"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var iris_1 = require("iris");
var pricing_category_1 = require("iris/dist/helpers/ibe/pricing_category");
// query airport data from backend API
function fetchAirports(store, request) {
    return __awaiter(this, void 0, void 0, function () {
        var key, cachedGateways, gateways, _a, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    request.adults = 2;
                    request.juveniles = 0;
                    request.children = 0;
                    request.pricingCategory = pricing_category_1.Flex;
                    key = JSON.stringify(request);
                    store.commit('SET_LOADING', key);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    cachedGateways = store.getters['cachedGatewaysFor'](request.priceModel);
                    if (!(cachedGateways !== null && cachedGateways !== void 0)) return [3 /*break*/, 2];
                    _a = cachedGateways;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, iris_1.client.gateways(request)];
                case 3:
                    _a = (_b.sent());
                    _b.label = 4;
                case 4:
                    gateways = (_a);
                    if (store.getters['lastFetchRequestKey'] === key) {
                        if (!cachedGateways) {
                            store.commit('SET_GATEWAYS_CACHE_FOR', { priceModel: request.priceModel, gateways: gateways });
                        }
                        store.commit('IMPORT_AIRPORTS', gateways);
                        store.commit('SET_LOADING', '');
                    }
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    console.error('error on fetchAirports: ', e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// query data from the backend API
function fetchFlexFlights(store, options) {
    return __awaiter(this, void 0, void 0, function () {
        var request, key, timeBefore, flexFlights, timeAfter, duration, seconds, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store.commit('IMPORT', []);
                    request = {
                        cruiseId: options.cruiseId,
                        adults: options.adults,
                        children: options.children,
                        direction: store.getters['selectedDirectionCode'],
                        gateway: store.getters['selectedAirportCode'],
                        juveniles: options.juveniles,
                        priceModel: options.priceModel,
                        transportationClass: store.getters['selectedClassCode'],
                        birthdates: options.birthdates,
                        carrier: store.getters['selectedAirlineCodes'],
                        nonstop: store.getters['nonstop'],
                        channel: options.isExpinetOrigin ? 'EXT' : 'IBE'
                    };
                    key = JSON.stringify(request);
                    store.commit('SET_LOADING', key);
                    store.commit('SET_FETCH_TIME', 0);
                    timeBefore = new Date().getTime();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, iris_1.client.flexFlights(request)];
                case 2:
                    flexFlights = _a.sent();
                    timeAfter = new Date().getTime();
                    duration = timeAfter - timeBefore;
                    seconds = Math.floor(duration / 1000);
                    store.commit('SET_FETCH_TIME', seconds);
                    if (store.getters['lastFetchRequestKey'] === key) {
                        store.commit('RESET_SELECTED_FLIGHT');
                        store.commit('IMPORT', flexFlights);
                        store.commit('SET_LOADING', '');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error('error on fetchFlexFlights: ', e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function setFlightClass(store, code) {
    store.commit('SELECT_FLIGHT_CLASS', code);
    store.commit('RESET_RNF_STATE');
}
function setFlightDirection(store, code) {
    store.commit('SELECT_FLIGHT_DIRECTION', code);
    store.commit('RESET_RNF_STATE');
}
// actually select one of the available airports
function selectAirport(store, code) {
    store.commit('SELECT_AIRPORT', code);
    store.commit('RESET_RNF_STATE');
}
function toggleAirlineCode(store, code) {
    store.commit('SET_OR_TOGGLE_AIRLINE_CODE', { code: code });
}
function setNonstop(store, nonstop) {
    store.commit('SET_NONSTOP', nonstop);
}
// actually select one of the available flights
function selectFlight(store, code) {
    var list = store.getters['flexFlights'];
    var valid = lodash_1.find(list, function (flight) { return flight.id === code; });
    if (valid) {
        store.commit('SELECT_FLIGHT', code);
    }
}
function setStep(store, step) {
    store.commit('SET_STEP', step);
}
function resetStore(store) {
    store.commit('RESET_STATE');
}
function resetRnf(store) {
    store.commit('RESET_RNF_STATE');
}
exports.resetRnf = resetRnf;
function resetRnfPremium(store) {
    store.commit('RESET_RNF_STATE');
    if (store.getters['validDepartureRnf']) {
        store.commit('SET_RNF_DEPARTURE', true);
    }
    if (store.getters['validArrivalRnf']) {
        store.commit('SET_RNF_ARRIVAL', true);
    }
}
exports.resetRnfPremium = resetRnfPremium;
function mark(store) {
    store.commit('MARK_AS_TOUCHED');
}
exports.mark = mark;
function rnfTotalPrice(store) {
    store.commit('SET_RNF_TOTAL_PRICE');
}
exports.rnfTotalPrice = rnfTotalPrice;
// tslint:disable-next-line:cyclomatic-complexity
function setRnfDirection(store, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (data.direction === 'arrival') {
                store.commit('SET_RNF_ARRIVAL', data.value);
            }
            else if (data.direction === 'departure') {
                store.commit('SET_RNF_DEPARTURE', data.value);
            }
            return [2 /*return*/];
        });
    });
}
exports.setRnfDirection = setRnfDirection;
function findTransportations(store, data) {
    return __awaiter(this, void 0, void 0, function () {
        var result, direction, directions, _i, directions_1, explicitDirection, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    direction = store.getters['rnfDirection'];
                    directions = (direction == 'OJ') ? ['O', 'R'] : [direction];
                    _i = 0, directions_1 = directions;
                    _a.label = 1;
                case 1:
                    if (!(_i < directions_1.length)) return [3 /*break*/, 4];
                    explicitDirection = directions_1[_i];
                    request = createRequest(store, data, explicitDirection);
                    return [4 /*yield*/, iris_1.client.railTransport(request)];
                case 2:
                    response = _a.sent();
                    result.push.apply(result, mapToTransport(response));
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    store.commit('SET_TRANSPORTATION', result);
                    return [2 /*return*/];
            }
        });
    });
}
exports.findTransportations = findTransportations;
// apply a priceDiffer or resets if no value given
function priceDiffer(store, differ) {
    if (!!differ) {
        store.commit('SET_PRICE_DIFFER', differ);
    }
    else {
        if (store.getters['priceDiffer'] !== 0) {
            store.commit('SET_PRICE_DIFFER', 0);
        }
    }
}
exports.priceDiffer = priceDiffer;
// export everything compliant to the vuex specification for actions
exports.default = {
    fetchAirports: fetchAirports,
    fetchFlexFlights: fetchFlexFlights,
    findTransportations: findTransportations,
    priceDiffer: priceDiffer,
    resetRnf: resetRnf,
    resetRnfPremium: resetRnfPremium,
    resetStore: resetStore,
    rnfTotalPrice: rnfTotalPrice,
    selectAirport: selectAirport,
    selectFlight: selectFlight,
    setFlightClass: setFlightClass,
    setFlightDirection: setFlightDirection,
    setNonstop: setNonstop,
    setRnfDirection: setRnfDirection,
    setStep: setStep,
    toggleAirlineCode: toggleAirlineCode,
};
// tslint:disable-next-line:cyclomatic-complexity
function createRequest(store, data, explicitDirectionTrain) {
    var request = {
        cruiseID: data.cruiseId,
        adults: data.adults,
        juveniles: data.juveniles,
        children: data.children,
        paxe: getPaxRailInfo(data),
        priceModel: data.priceModel,
        transClass: store.getters['rnfCategory'],
        direction: explicitDirectionTrain,
        gateway: store.getters['selectedAirportCode'],
        transportationType: 'RNF'
    };
    return request;
}
// tslint:disable-next-line:cyclomatic-complexity
function getPaxRailInfo(data) {
    var paxInfos = [];
    if (data.birthday0) {
        paxInfos.push({
            birthday: data.birthday0,
        });
    }
    if (data.birthday1) {
        paxInfos.push({
            birthday: data.birthday1,
        });
    }
    if (data.birthday2) {
        paxInfos.push({
            birthday: data.birthday2,
        });
    }
    if (data.birthday3) {
        paxInfos.push({
            birthday: data.birthday3,
        });
    }
    if (data.birthday4) {
        paxInfos.push({
            birthday: data.birthday4,
        });
    }
    return paxInfos;
}
function mapToTransport(railTransports) {
    var transportations = [];
    for (var _i = 0, railTransports_1 = railTransports; _i < railTransports_1.length; _i++) {
        var railTransport = railTransports_1[_i];
        var pricings = {
            Pricing: [],
        };
        var referencePrice = 0;
        for (var _a = 0, _b = railTransport.pricings.Pricing; _a < _b.length; _a++) {
            var pricing = _b[_a];
            pricings.Pricing.push({
                amount: pricing.amount,
                currency: 'EUR',
            });
            referencePrice += parseFloat(pricing.amount);
        }
        transportations.push({
            code: railTransport.code,
            type: 'RNF',
            tariffType: railTransport.transportationSegments[0].tariff,
            direction: railTransport.direction,
            transportationClass: railTransport.transClass,
            pricings: pricings,
            referencePrice: referencePrice
        });
    }
    return transportations;
}
//# sourceMappingURL=actions.js.map